import { FlattenedItem } from "@/app/features/reports/utils/entities";
import { useScrollContext } from "@/app/features/reports/contexts/scroll-context";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import React from "react";
import { useMemo } from "react";

interface GlobalSearchContext {
    flattenedItems: FlattenedItem[];
}

function GlobalSearchDialog({ flattenedItems }: GlobalSearchContext) {
    const [open, setOpen] = React.useState(false)
    const { scrollToHeader } = useScrollContext();

    React.useEffect(() => {

        const down = (e: KeyboardEvent) => {
            if (e.key === "j" && (e.metaKey || e.ctrlKey)) {
                e.preventDefault()
                setOpen((open) => !open)
            }
        }
        document.addEventListener("keydown", down)
        return () => document.removeEventListener("keydown", down)
    }, []);

    const filteredCommands = useMemo(() => {
        if (open) {
            return flattenedItems
                .filter(item => !item.content)
                .map(item => ({ id: item.id, label: item.parents?.join(' > ') || item.title }));
        }
        return [];
    }, [open, flattenedItems]);

    return (
        <CommandDialog open={open} onOpenChange={setOpen}>
            <CommandInput placeholder="Search..." />
            <CommandList>
                <CommandEmpty>No results.</CommandEmpty>
                <CommandGroup heading={`Go To`}>
                    {filteredCommands.map(cmd => (
                        <CommandItem
                            key={cmd.id}
                            onSelect={() => {
                                scrollToHeader(cmd.id, );
                                setOpen(false);
                            }}
                        >
                            {cmd.label}
                        </CommandItem>
                    ))}
                </CommandGroup>
            </CommandList>

        </CommandDialog>
    )
}

export default GlobalSearchDialog;